import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import { CmdTooltip } from '@commander-services/gui-components';
import {
  activeRideIndexAtom,
  actualPlayPositionAtom,
  selectedRidesAtom,
  showDataLayerAtom,
} from '../RidePlayerState';
import { IRide } from '../types';
import { isWidgetDisabled } from '../../OnlinePanel/Widgets/WidgetService';

interface IEcoScoreWidgetProps {
  rides: IRide[];
}

export default function EcoScoreWidget(props: IEcoScoreWidgetProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const actualPosition = useRecoilValue(actualPlayPositionAtom);
  const showContent = useRecoilValue(showDataLayerAtom);
  const activeRideIndex = useRecoilValue<number>(activeRideIndexAtom);
  const selectedRides = useRecoilValue<number[]>(selectedRidesAtom);
  const activeRideNumber = selectedRides[activeRideIndex];
  const rideIndex = activeRideNumber - 1;

  const currentPosition = props.rides[rideIndex]
    ? props.rides[rideIndex].positions[actualPosition]
    : null;
  const formattedEcoScore =
    currentPosition && typeof currentPosition.ecoScore === 'number' && showContent
      ? currentPosition.ecoScore
      : '-';

  let iconColor = '#04b590';
  let iconType = 'good';
  let textColor = '#494949';
  if (formattedEcoScore !== null) {
    if (Number(formattedEcoScore) <= 4.9) {
      iconColor = '#b50536';
      iconType = 'bad';
      textColor = '#BA1140';
    } else if (Number(formattedEcoScore) >= 5.0 && Number(formattedEcoScore) <= 7.9) {
      iconColor = '#df731d';
      iconType = 'not-good';
      textColor = '#B85A1E';
    }
  }
  if (formattedEcoScore === null || formattedEcoScore === '-' || !showContent) {
    iconType = 'offline';
    iconColor = '#C8C8C8';
  }

  return (
    <div className="item">
      <div className="b-widget b-widget--1x1" style={{ position: 'initial', textAlign: 'center' }}>
        <CmdTooltip
          customCss={{ whiteSpace: 'nowrap', top: '53px' }}
          content={f({ id: 'ridePlayer.widget.ecoDrive.tooltip' })}
          style={{ display: 'block' }}
          width={180}
        >
          <i
            className={`e-widget-icon cmd-icon cmd-icon-eco-drive-${iconType} ${isWidgetDisabled(
              formattedEcoScore
            )}`}
            style={{ color: iconColor }}
          />
          <div
            className={`e-widget-value ${isWidgetDisabled(formattedEcoScore)}`}
            style={{ textAlign: 'center' }}
          >
            <strong style={{ color: textColor }}>{formattedEcoScore}</strong>
          </div>
        </CmdTooltip>
      </div>
    </div>
  );
}
